import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';

export type CreateUserOtpCodeParams = WithParams<{
  mobile_number?: string;
}>;

export class UserOtpCodeApi {
  static create = async (params: CreateUserOtpCodeParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/otp_code`, snakes(params));
  };
}
